//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/mixins/global'
import chartOTP from '../../components/chartSM3'
import axios from 'axios'

export default {
  components: {
    chartOTP
  },
  data () {
    return {
      refreshComponent: false,
      G1: true,
      G2: true,
      G3: true,
      G4: true,
      VN: true,
      TRM: true,
      ps: '',
      pe: '',
      deptg1: {},
      deptg2: {},
      deptg3: {},
      deptg4: {},
      deptvn: {},
      depttrm: {},
      g1: 'G1',
      g2: 'G2',
      g3: 'G3',
      g4: 'G4',
      trm: 'G5',
      vn: 'VN2',
      eps: '',
      epe: '',
      wipday: 2
    }
  },
  async mounted () {
    await this.defaultPeriod()

    this.deptg1 = await axios(
      `${this.$apiflask}nygctroom/board4/perform/G1/${this.ps}/${this.pe}`
    )
    this.deptg2 = await axios(
      `${this.$apiflask}nygctroom/board4/perform/G2/${this.ps}/${this.pe}`
    )
    this.deptg3 = await axios(
      `${this.$apiflask}nygctroom/board4/perform/G3/${this.ps}/${this.pe}`
    )
    this.deptg4 = await axios(
      `${this.$apiflask}nygctroom/board4/perform/G4/${this.ps}/${this.pe}`
    )
    this.deptvn = await axios(
      `${this.$apiflask}nygctroom/board4/perform/VN2/${this.ps}/${this.pe}`
    )
    this.depttrm = await axios(
      `${this.$apiflask}nygctroom/board4/perform/G5/${this.ps}/${this.pe}`
    )
    // console.log(this.deptg4.data);
    this.loadData()
  },
  methods: {
    goPage (routerName) {
      this.$router.push({
        name: routerName
      })
    },

    defaultPeriod () {
      let params = new FormData()
      const obj = axios({
        method: 'post',
        url: this.$apiFix + '2021snapdata.php/defaultweek',
        data: params
      }).then(res => {
        this.ps = res.data.ps
        this.pe = res.data.pe
        this.eps = res.data.ps
        this.epe = res.data.pe
      })

      return obj
    },

    ExportData () {
      if (this.eps === '' || this.epe === '') {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: 'Please fill Week!',
          html: true
        })
        return false
      } else {
        window.open(
          `${this.$apiflask}nygctroom/board4/perform/export?ps=${this.eps}&pe=${
            this.epe
          }&g1=${this.g1}&g2=${this.g2}&g3=${this.g3}&g4=${this.g4}&trm=${
            this.trm
          }&vn=${this.vn}&uuid=${this.create_UUID()}`,
          '_export'
        )
      }
    },

    loadData () {
      this.refreshComponent = false
      this.pulling = setTimeout(() => {
        this.refreshComponent = true
      }, 500)
    }
  }
}
